export const formatDate = (date: Date): string => {

  const month = (date.getMonth() + 1).toString().padStart(2, "0");
  const day = date.getDate().toString().padStart(2, "0");
  const year = date.getFullYear().toString();

  return `${year}-${month}-${day}`;
};

export const formatDateMarriott = (val: string) => {
  const newDate = new Date(val);

  const month = (newDate.getMonth() + 1).toString().padStart(2, "0");
  const day = newDate.getDate().toString().padStart(2, "0");
  const year = newDate.getFullYear().toString().substring(2);

  return `${month}/${day}/${year}`;
}
